import { useState, Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddMuscleModal({ open, onClose, setOpen }: ModalProps) {
  const [muscle, setMuscle] = useState("");
  const [error, setError] = useState(false);

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">

          {/* Title */}
          <div className="modal_title">
            <h2>Add Muscle Group</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="control_group">
              <TextField
                placeholder="Muscle Group Name"
                fullWidth
                hiddenLabel
                value={muscle}
                onChange={(e) => setMuscle(e.target.value)}
              />
              {error && muscle === "" && (
                <h6 className="err_msg">Muscle group name is required</h6>
              )}
            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => {
                  setError(true);
                  if (muscle === "") return;
                  setError(false);
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}
